import request from '@/utils/https';
import { fileService } from "@/api/common/file-utils";


export default {
    // 获取评分类型列表
    getSummaryApage: (param) => {
        return request({
            url: `/appraise/AAA/summary/pageList`,
            method: 'post',
            data: param
        });
    },
    // 评分汇总发送邮件
    sendEmail: (param) => {
        return request({
            url: `/appraise/AAA/summary/sendEmail`,
            method: 'post',
            data: param
        });
    },
    // 评分汇总发布
    summaryRelease: (param) => {
        return request({
            url: `/appraise/AAA/summary/release`,
            method: 'post',
            data: param
        });
    },
    // 评分细项
    getScoreDetail: (id) => {
        return request({
            url: `/appraise/AAA/scoreDetail/${id}`,
            method: 'get',
        });
    },
    // 汇总导出
    exportSummary: (param) => {
        return request({
            url: `/appraise/AAA/summary/export`,
            method: 'post',
            data: param,
            responseType: "blob",
            fullResponse: true,
        })
    },
    // 导出评分级Facts
    exportScoreAndFacts: (param) => {
        return request({
            url: `/appraise/AAA/summary/exportScoreAndFacts`,
            method: 'post',
            data: param,
            responseType: "blob",
            fullResponse: true,
        })
    },
    // 导出评分级Facts
    exportSupplierRank: (param,id) => {
        return request({
            url: `/appraise/AAA/summary/exportSupplierRank/${id}`,
            method: 'post',
            data: param,
            responseType: "blob",
            fullResponse: true,
        })
    },
    // 导出供应商报表
    exportSupplierChart: (param,id) => {
        return request({
            url: `/appraise/AAA/summary/exportSupplierChart/${id}`,
            method: 'post',
            data: param,
            responseType: "blob",
            fullResponse: true,
        })
    },
}



